import React from 'react';
import { connect } from 'react-redux';
import { omit } from '../../utils/object';
import { trackEvent as trackEventAction } from '../../actions/tracking';

if (process.browser) require('./Button.scss');

const EXCLUDE_PROPS = [
  'track',
  'trackEvent',
  'match',
  'location',
  'history',
  'onClick',
  'profile_uuid'
];

const mapStateToProps = ({ session }) => ({
  profile_uuid: session ? session.user : null // eslint-disable-line camelcase
});

const mapDispatchToProps = {
  trackEvent: trackEventAction
};

const Button = ({
  buttonStyle = 'primary',
  fluid = false,
  className = '',
  children,
  track,
  trackEvent,
  onClick,
  withIcon,
  ...props
}) => {
  const otherProps = omit(EXCLUDE_PROPS, props);

  const handleClick = (e) => {
    const { profile_uuid } = props; // eslint-disable-line camelcase
    const { type } = e;
    const label = e.target.innerText;

    if (track) {
      trackEvent({
        ...track,
        profile_uuid,
        label,
        type
      });
    }

    if (onClick) onClick(e);
  };

  const classes = `button-${buttonStyle} ${className} ${fluid ? 'button-fluid text-center' : ''} ${withIcon ? 'with-icon-after' : ''}`;

  return (
    <button className={classes} onClick={handleClick} {...otherProps}>
      { children }
    </button>
  );
};

Button.propTypes = {
  // eslint-disable-next-line react/require-default-props
  track: ({ track, disabled }) =>
    !disabled && !track && new Error('Track prop not supplied to clickable Button')
};

export default connect(mapStateToProps, mapDispatchToProps)(Button);



// WEBPACK FOOTER //
// ./src/universal/ui/components/Button/Button.js